export const firebaseConfig = {
    apiKey: "AIzaSyC6DALmsnNatl73YBAOLFaVsem1lpK28xE",
    authDomain: "notituyendung.firebaseapp.com",
    projectId: "notituyendung",
    storageBucket: "notituyendung.appspot.com",
    messagingSenderId: "527643207465",
    appId: "1:527643207465:web:b62d2f5f784e21eac9f938",
    measurementId: "G-L3N3PZ1MP0"
};
// export const firebaseConfig = {
//     apiKey: "AIzaSyB1YvGViJjnK29fmbVsh3Pc3OimiwMMpv4",
//     authDomain: "findjobproject-96c36.firebaseapp.com",
//     projectId: "findjobproject-96c36",
//     storageBucket: "findjobproject-96c36.firebasestorage.app",
//     messagingSenderId: "581090010990",
//     appId: "1:581090010990:web:fbb2e8973afb93508f837f",
//     measurementId: "G-Z63638FY6D"
//   };